import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Table from "@material-ui/core/Table"
import TableHead from "@material-ui/core/TableHead"
import TableBody from "@material-ui/core/TableBody"
import TableRow from "@material-ui/core/TableRow"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import Divider from "@material-ui/core/Divider"
import PropTypes from "prop-types"

const useStyles = makeStyles((theme) => ({
	container: {
		maxHeight: 420,
		[theme.breakpoints.down("xs")]: {
			maxHeight: 220,
		},
	},
	clickable: {
		cursor: "pointer",
	},
	valueCell: {
		textAlign: "right",
	},
	error: {
		color: "red",
	},
}))

const sortByDesc = (a, b) => {
	let nameA = a.description.toUpperCase() // ignore upper and lowercase
	let nameB = b.description.toUpperCase() // ignore upper and lowercase

	if (nameA < nameB) {
		return -1
	}
	if (nameA > nameB) {
		return 1
	}

	// names must be equal
	return 0
}

const NodesSummary = (props) => {
	const { summaryNodeCount, duplicatesSummary, summaryData, summaryHeading, visibilityMasks, handleFilterChange } =
		props
	const classes = useStyles()

	return (
		<>
			<Divider />
			<Divider />
			{duplicatesSummary && (
				<>
					<Table size="small">
						<TableHead>
							<TableRow>
								<TableCell>Problems with node IDs detected</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{duplicatesSummary.map((duplicateMessage) => (
								<TableRow
									key={
										/** @type {string} */
										duplicateMessage
									}
								>
									<TableCell className={classes.error}>
										{
											/** @type {string} */
											duplicateMessage
										}
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
					<Divider />
					<Divider />
				</>
			)}
			<Table size="small">
				<TableBody>
					{summaryNodeCount !== null ? (
						Object.keys(summaryNodeCount).map((dataRow) => (
							<TableRow key={dataRow}>
								<TableCell>{dataRow}</TableCell>
								<TableCell className={classes.valueCell}>{summaryNodeCount[dataRow]}</TableCell>
							</TableRow>
						))
					) : (
						<TableRow>
							<TableCell>No Data</TableCell>
							<TableCell></TableCell>
						</TableRow>
					)}
				</TableBody>
			</Table>
			{summaryHeading !== null && (
				<>
					<Divider />
					<Divider />
					<TableContainer className={classes.container}>
						<Table size="small" stickyHeader>
							<TableHead>
								<TableRow>
									{summaryHeading.map((headingDesc, ind, { length }) => (
										<TableCell key={headingDesc} className={ind === length - 1 && classes.valueCell}>
											{headingDesc}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{summaryData === null ? (
									<TableRow>
										<TableCell>No Data</TableCell>
										<TableCell></TableCell>
									</TableRow>
								) : summaryData.length === 0 ? (
									<TableRow>
										<TableCell>None</TableCell>
										<TableCell></TableCell>
									</TableRow>
								) : (
									summaryData.sort(sortByDesc).map((dataRow, index) => {
										const group = Math.floor(dataRow.action / 16)
										const bit = 1 << dataRow.action % 16
										const alarmVisibilitySelected = (visibilityMasks[group] & bit) !== 0
										let selectAction = null
										if (dataRow.action !== null) {
											selectAction = (e) => {
												handleFilterChange(e, dataRow.action)
											}
										}
										return (
											<TableRow
												key={index}
												className={dataRow.action === null ? undefined : classes.clickable}
												hover={Boolean(dataRow.action)}
												selected={alarmVisibilitySelected}
												onClick={selectAction}
											>
												<TableCell>{dataRow.description}</TableCell>
												<TableCell className={classes.valueCell}>{dataRow.value}</TableCell>
											</TableRow>
										)
									})
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</>
			)}
		</>
	)
}

NodesSummary.propTypes = {
	summaryData: PropTypes.arrayOf(PropTypes.object),
	summaryNodeCount: PropTypes.object.isRequired,
	duplicatesSummary: PropTypes.arrayOf(PropTypes.string),
	summaryHeading: PropTypes.any,
	alarmsSummary: PropTypes.arrayOf(PropTypes.object),
	visibilityMasks: PropTypes.arrayOf(PropTypes.number),
	handleFilterChange: PropTypes.func,
}

export default NodesSummary
